module.exports = __webpack_public_path__ + "./assets/fonts/Gilroy-Light.ttf?c5ba9f21ca8024e2e6739f6164dffbf2";